import { getPath, getInitialState } from "../../utils";
import { clean } from "../../components/GenSetting/HelperFunctions";
const initialState = {
  level: {},
  order: {},
  levelName: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_LEVEL":
      return setLevelList(state, action);
    case "RESET_STATE_LEVEL":
      return resetState(state, action);
    case "SET_ORDER":
      return setOrder(state, action);
    default:
      return state;
  }
}

const setLevelList = (state, action) => {
  return {
    ...state,
    level: clean(getPath(action.payload, "level", {})),
    order: getPath(action.payload, "order", {}),
    levelName: getPath(action.payload, "level_name", ""),
  };
};

const setOrder = (state, action) => {
  return {
    ...state,
    order: action.payload,
  };
};

const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};
